"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectUtils = void 0;
const each_1 = __importDefault(require("lodash/each"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const isDate_1 = __importDefault(require("lodash/isDate"));
const isNil_1 = __importDefault(require("lodash/isNil"));
const isObjectLike_1 = __importDefault(require("lodash/isObjectLike"));
const isString_1 = __importDefault(require("lodash/isString"));
var ObjectUtils;
(function (ObjectUtils) {
    let CompactOptions;
    (function (CompactOptions) {
        CompactOptions.compactEverything = {
            compactEmptyString: true,
            compactEmptyArray: true,
            compactEmptyObject: true,
        };
    })(CompactOptions = ObjectUtils.CompactOptions || (ObjectUtils.CompactOptions = {}));
    /**
     * Recursively compacts the input, removing keys that have values that are
     * - null
     * - undefined
     * - empty string (optional)
     * - empty array (optional)
     * - empty object (optional)
     *
     * Leave maxDepth as undefined to recurse indefinitely
     */
    // eslint-disable-next-line sonarjs/cognitive-complexity
    function recursiveCompact(input, compactOptions = {}, maxDepth) {
        // Max depth reached
        if (!!maxDepth && maxDepth <= 0) {
            return input;
        }
        const nextDepth = (0, isNil_1.default)(maxDepth) ? undefined : maxDepth - 1;
        // Nil
        if ((0, isNil_1.default)(input)) {
            return undefined;
        }
        // String
        if (compactOptions.compactEmptyString && (0, isString_1.default)(input) && input.length === 0) {
            return undefined;
        }
        // Array
        if ((0, isArray_1.default)(input)) {
            let result = input;
            if ((0, isNil_1.default)(nextDepth) || nextDepth >= 0) {
                result = [];
                input.forEach((value) => {
                    const compactedValue = recursiveCompact(value, compactOptions, nextDepth);
                    if (!(0, isNil_1.default)(compactedValue))
                        result.push(compactedValue);
                });
            }
            if (compactOptions.compactEmptyArray && result.length === 0) {
                return undefined;
            }
            return result;
        }
        // Date
        if ((0, isDate_1.default)(input)) {
            return input;
        }
        // Object
        if ((0, isObjectLike_1.default)(input)) {
            let result = input;
            if ((0, isNil_1.default)(nextDepth) || nextDepth >= 0) {
                result = {};
                (0, each_1.default)(input, (value, key) => {
                    const compactedValue = recursiveCompact(value, compactOptions, nextDepth);
                    if (!(0, isNil_1.default)(compactedValue)) {
                        result[key] = compactedValue;
                    }
                });
            }
            if (compactOptions.compactEmptyObject && Object.keys(result).length === 0) {
                return undefined;
            }
            return result;
        }
        return input;
    }
    ObjectUtils.recursiveCompact = recursiveCompact;
    /**
     * Removes first level keys that have values that are
     * - null
     * - undefined
     * - empty string (optional)
     * - empty array (optional)
     * - empty object (optional)
     */
    function compactObject(input, compactOptions = {}) {
        return recursiveCompact(input, compactOptions, 1);
    }
    ObjectUtils.compactObject = compactObject;
})(ObjectUtils || (exports.ObjectUtils = ObjectUtils = {}));
//# sourceMappingURL=ObjectUtils.js.map